import { useEffect, useState } from 'react'
import AdminLayout from '../../components/AdminLayout'
import { adminGetBarrios, adminCrearBarrio, adminActualizarBarrio } from '../../lib/portalClienteApi'

const DIAS_DISPONIBLES = [
  { id: 'lunes',     label: 'Lun', full: 'Lunes' },
  { id: 'martes',    label: 'Mar', full: 'Martes' },
  { id: 'miercoles', label: 'Mié', full: 'Miércoles' },
  { id: 'jueves',    label: 'Jue', full: 'Jueves' },
  { id: 'viernes',   label: 'Vie', full: 'Viernes' },
]

export default function Barrios() {
  const [barrios, setBarrios] = useState([])
  const [loading, setLoading] = useState(true)
  const [modal, setModal] = useState(null)  // null | { barrio: ... } (null para nuevo)
  const [filtro, setFiltro] = useState('todos')  // todos | activos | inactivos

  useEffect(() => { load() }, [])

  async function load() {
    setLoading(true)
    setBarrios(await adminGetBarrios())
    setLoading(false)
  }

  const filtrados = barrios.filter(b => {
    if (filtro === 'activos')   return b.activo
    if (filtro === 'inactivos') return !b.activo
    return true
  })

  const totalClientes = barrios.reduce((s, b) => s + Number(b.clientes_activos || 0), 0)

  return (
    <AdminLayout>
      <div className="page">
        <h1>Barrios</h1>
        <p className="lead">Cobertura · días de reparto · clientes por zona</p>
        <div className="cards-grid" style={{ marginBottom: 16 }}>
          <div className="card">
            <h3>Total barrios</h3>
            <div className="stat">{barrios.length}</div>
          </div>
          <div className="card">
            <h3>Activos</h3>
            <div className="stat" style={{ color: 'var(--teal)' }}>{barrios.filter(b => b.activo).length}</div>
          </div>
          <div className="card">
            <h3>Clientes activos</h3>
            <div className="stat">{totalClientes}</div>
            <div className="desc">Sumando todos los barrios</div>
          </div>
        </div>

        <div className="btn-row" style={{ alignItems: 'center', flexWrap: 'wrap' }}>
          <button className="btn primary" onClick={() => setModal({ barrio: null })}>+ Nuevo barrio</button>
          <button className="btn ghost" onClick={load}>↺</button>
          <div style={{ flex: 1 }} />
          <div style={{ display: 'flex', gap: 4, background: '#F1F5F9', borderRadius: 999, padding: 4 }}>
            {[
              { id: 'todos', label: 'Todos' },
              { id: 'activos', label: 'Activos' },
              { id: 'inactivos', label: 'Inactivos' },
            ].map(f => (
              <button key={f.id} className="btn ghost"
                onClick={() => setFiltro(f.id)}
                style={{
                  padding: '6px 14px', fontSize: 12, borderRadius: 999,
                  background: filtro === f.id ? '#fff' : 'transparent',
                  border: filtro === f.id ? '1px solid var(--line)' : '1px solid transparent',
                  fontWeight: filtro === f.id ? 700 : 500,
                }}>
                {f.label}
              </button>
            ))}
          </div>
        </div>

        {loading ? (
          <div className="card" style={{ textAlign: 'center', color: 'var(--muted)' }}>Cargando...</div>
        ) : filtrados.length === 0 ? (
          <div className="card" style={{ textAlign: 'center', color: 'var(--muted)' }}>
            No hay barrios {filtro !== 'todos' ? `(${filtro})` : ''}.
          </div>
        ) : (
          <table className="t-table">
            <thead>
              <tr>
                <th>Barrio</th>
                <th>Días de reparto</th>
                <th style={{ textAlign: 'right' }}>Clientes activos</th>
                <th>Estado</th>
                <th>Notas</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {filtrados.map(b => (
                <tr key={b.id} style={{ opacity: b.activo ? 1 : 0.5 }}>
                  <td>
                    <div style={{ fontWeight: 700 }}>{b.nombre}</div>
                  </td>
                  <td>
                    <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                      {DIAS_DISPONIBLES.map(d => {
                        const activo = (b.dias || []).includes(d.id)
                        return (
                          <span key={d.id} style={{
                            display: 'inline-block', padding: '3px 9px', borderRadius: 6, fontSize: 11,
                            fontWeight: 700, letterSpacing: '.04em', textTransform: 'uppercase',
                            background: activo ? 'var(--teal-bg, #DCFCE7)' : '#F1F5F9',
                            color: activo ? '#065F46' : '#94A3B8',
                            border: activo ? '1px solid #86EFAC' : '1px solid transparent',
                          }}>
                            {d.label}
                          </span>
                        )
                      })}
                    </div>
                  </td>
                  <td style={{ textAlign: 'right', fontWeight: 800 }}>{b.clientes_activos || 0}</td>
                  <td>
                    <span style={{
                      background: b.activo ? '#D1FAE5' : '#FEE2E2',
                      color:      b.activo ? '#065F46' : '#991B1B',
                      padding: '3px 9px', borderRadius: 999,
                      fontSize: 11, fontWeight: 700,
                      textTransform: 'uppercase', letterSpacing: '.06em',
                    }}>
                      {b.activo ? '● Activo' : 'Inactivo'}
                    </span>
                  </td>
                  <td style={{ fontSize: 12, color: 'var(--muted)', maxWidth: 260 }}>
                    {b.notas || '—'}
                  </td>
                  <td>
                    <button className="btn ghost" style={{ padding: '4px 10px', fontSize: 11 }} onClick={() => setModal({ barrio: b })}>
                      Editar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {modal !== null && (
          <BarrioModal
            barrio={modal.barrio}
            barrios={barrios}
            onClose={() => setModal(null)}
            onDone={() => { setModal(null); load() }}
          />
        )}

        <p style={{ marginTop: 16, fontSize: 12, color: 'var(--muted)' }}>
          ⚠️ Por ahora <strong>solo días hábiles</strong> (lunes a viernes). Sábado y domingo no están permitidos para reparto.
        </p>
      </div>
    </AdminLayout>
  )
}

function BarrioModal({ barrio, barrios, onClose, onDone }) {
  const esNuevo = !barrio
  const [form, setForm] = useState({
    nombre: barrio?.nombre || '',
    dias:   barrio?.dias   || [],
    notas:  barrio?.notas  || '',
    activo: barrio?.activo ?? true,
  })
  const [saving, setSaving] = useState(false)
  const [err, setErr] = useState(null)

  function toggleDia(d) {
    setForm(f => ({
      ...f,
      dias: f.dias.includes(d) ? f.dias.filter(x => x !== d) : [...f.dias, d],
    }))
  }

  async function handleSubmit(e) {
    e.preventDefault()
    setErr(null)
    if (!form.nombre.trim()) { setErr('Falta el nombre del barrio.'); return }
    if (form.dias.length === 0) { setErr('Tenés que elegir al menos un día de reparto.'); return }
    // validar duplicados (solo en alta)
    if (esNuevo) {
      const yaExiste = barrios.some(b => b.nombre.toLowerCase().trim() === form.nombre.toLowerCase().trim())
      if (yaExiste) { setErr('Ya existe un barrio con ese nombre.'); return }
    }
    setSaving(true)
    try {
      const datos = {
        nombre: form.nombre.trim(),
        dias: form.dias,
        notas: form.notas.trim() || null,
      }
      if (esNuevo) await adminCrearBarrio(datos)
      else await adminActualizarBarrio(barrio.id, { ...datos, activo: form.activo })
      onDone()
    } catch (e) {
      setErr(e.message?.includes('duplicate') ? 'Ya existe un barrio con ese nombre.' : (e.message || String(e)))
    } finally { setSaving(false) }
  }

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(15,31,61,.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 14, padding: 28, maxWidth: 540, width: '100%', maxHeight: '90vh', overflowY: 'auto' }}>
        <h2 style={{ marginBottom: 18 }}>{esNuevo ? 'Nuevo barrio' : `Editar ${barrio.nombre}`}</h2>

        {!esNuevo && Number(barrio.clientes_activos || 0) > 0 && (
          <div style={{ background: '#FEF3C7', border: '1px solid #FCD34D', color: '#78350F', padding: '10px 14px', borderRadius: 10, fontSize: 12, marginBottom: 16 }}>
            ℹ️ Este barrio tiene <strong>{barrio.clientes_activos}</strong> clientes activos. Cambiar los días afecta sus rutas de entrega.
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <Field label="Nombre del barrio" required>
            <input type="text" required value={form.nombre}
              onChange={e => setForm({...form, nombre: e.target.value})}
              placeholder="Ej: Carrasco" />
          </Field>

          <Field label="Días de reparto" required>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
              {DIAS_DISPONIBLES.map(d => {
                const sel = form.dias.includes(d.id)
                return (
                  <button type="button" key={d.id}
                    onClick={() => toggleDia(d.id)}
                    style={{
                      padding: '10px 16px', borderRadius: 10, fontSize: 13, fontWeight: 700,
                      cursor: 'pointer', fontFamily: 'inherit',
                      background: sel ? 'var(--teal, #14B8A6)' : '#F8FAFC',
                      color: sel ? '#fff' : 'var(--navy-ink, #1A3461)',
                      border: sel ? '1.5px solid var(--teal, #14B8A6)' : '1.5px solid var(--line, #E2E8F0)',
                      transition: 'background .15s, color .15s, border-color .15s',
                    }}>
                    {d.full}
                  </button>
                )
              })}
            </div>
            <div style={{ marginTop: 6, fontSize: 11, color: 'var(--muted)' }}>
              Tocá los días en que la camioneta pasa por este barrio. Solo lunes a viernes.
            </div>
          </Field>

          <Field label="Notas internas (opcional)">
            <textarea value={form.notas}
              onChange={e => setForm({...form, notas: e.target.value})}
              rows="2"
              placeholder="Ej: Zona compleja para estacionar · Coordinación con encargados de edificio" />
          </Field>

          {!esNuevo && (
            <Field label="Estado">
              <label style={{ fontSize: 14 }}>
                <input type="checkbox" checked={form.activo}
                  onChange={e => setForm({...form, activo: e.target.checked})}
                  style={{ width: 'auto', marginRight: 8 }} />
                Barrio activo (visible para clientes nuevos)
              </label>
              {!form.activo && Number(barrio.clientes_activos || 0) > 0 && (
                <div style={{ marginTop: 6, fontSize: 11, color: '#B45309' }}>
                  ⚠️ Si lo desactivás, no podrán nuevos clientes elegirlo, pero los {barrio.clientes_activos} actuales siguen recibiendo entregas.
                </div>
              )}
            </Field>
          )}

          {err && <div className="err-box">{err}</div>}

          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 16 }}>
            <button type="button" className="btn ghost" onClick={onClose}>Cancelar</button>
            <button type="submit" className="btn primary" disabled={saving}>
              {saving ? 'Guardando...' : (esNuevo ? 'Crear barrio' : 'Guardar cambios')}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

function Field({ label, children, required }) {
  return (
    <label style={{ display: 'block', marginBottom: 14 }}>
      <b style={{ display: 'block', fontSize: 11, fontWeight: 700, color: 'var(--navy-ink, #1A3461)', letterSpacing: '.08em', textTransform: 'uppercase', marginBottom: 6 }}>
        {label} {required && <span style={{ color: 'var(--err, #DC2626)' }}>*</span>}
      </b>
      {children}
    </label>
  )
}
